var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerMeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 307,
    height: 80,
    viewBox: "0 0 307 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M1 27.0875V27.5002L1.29109 27.7928L48.9031 75.649L49.6089 76.3585L50.3178 75.6521L80.4324 45.6456V100V101H81.4324H97.1052H98.1052V100V5V2.58554L96.398 4.29294L49.6111 51.0866L2.70627 4.29206L1 2.5898V5V27.0875ZM101.966 97.9596L101.645 98.2565V98.6937V100V101H102.645H165.93H166.93V100V84.0875V83.0875H165.93H118.436H118.045L117.757 83.3534L101.966 97.9596ZM102.645 4H100.244L101.935 5.7044L117.727 21.6169L118.02 21.9125H118.436H165.93H166.93V20.9125V5V4H165.93H102.645ZM102.645 43.6625H101.645V44.6625V60.4563V61.4563H102.645H118.436H165.93H166.93V60.4563V44.6625V43.6625H165.93H118.436H102.645ZM178.128 4H177.128V5V20.9125V100V101H178.128H194.039H195.039V100V21.9125H225.622H226.622V20.9125V5V4H225.622H178.128ZM255.788 42.7426L268.789 68.8581L269.064 69.4125H269.684H287.494H289.112L288.388 67.9653L256.686 4.55284L255.792 2.76368L254.898 4.55284L207.404 99.5528L206.681 101H208.299H225.871H226.485L226.763 100.452L234.837 84.54L234.84 84.5347L242.675 68.8612L242.676 68.8597L255.788 42.7426ZM296.223 83.7564L295.946 83.2063H295.33H277.758H276.145L276.862 84.6507L284.698 100.444L284.974 101H285.594H303.285H304.909L304.178 99.5502L296.223 83.7564Z",
    stroke: "#00FF3F",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerMeta);
export default __webpack_public_path__ + "static/media/banner-meta.4d54bb9b29dabb445c543a95c52541e7.svg";
export { ForwardRef as ReactComponent };